// 借入相談変更中（確認）
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import { StepNavigation as StepType } from '../../types/Template';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import HeadingM from '../../molecules/HeadingM';
import FooterBorrowingConsultationInputConfirmation from '../../organisms/FooterBorrowingConsultationInputConfirmation';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  reception_id: number;
  status_code: number;
  is_staff: boolean;
  moveNextStep: () => void;
  movePrevStep: VoidFunction;
  guarantors_num: number;
  is_loading: boolean;
  display_status: boolean;
  show_error_nav: boolean;
  requestModule: () => void;
  callApi: (function_name: string) => Promise<any>;
  guarantor_info: GuarantorInfo;
}

const BorrowingConsultationChangeConfirm: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  looks_inactive,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  reception_id,
  status_code,
  is_staff,
  moveNextStep,
  movePrevStep,
  guarantors_num,
  is_loading,
  display_status,
  show_error_nav,
  requestModule,
  callApi,
  guarantor_info,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <HeadingM label="お申込情報"></HeadingM>
      <Reception
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        looks_inactive={looks_inactive}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={callApi}
        guarantor_info={guarantor_info}
      />
      <FooterBorrowingConsultationInputConfirmation
        applied={true}
        is_change={true}
        is_staff={is_staff}
        reception_cd={reception_cd}
        reception_id={reception_id}
        status_code={status_code}
        moveNextStep={moveNextStep}
        movePrevStep={movePrevStep}
        requestModule={requestModule}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default BorrowingConsultationChangeConfirm;
